
<div>
  <panel-block id="pn-default-date-value" v-if="isFormElement">
    <panel-item>
      <date-default-value-selector
        :datetime-mode="datetimeMode"
        :parent="model"
        field-name="default_datetime"
        :allow-formula="allowFormula"
        :dynamic-options="formulaDynamicFieldsOptions"
        :date-picker-props="{min: minDatetime, max: maxDatetime}"
      >
        <template #label>
          <slot name="minLabel"></slot>
        </template>
      </date-default-value-selector>
    </panel-item>
  </panel-block>

  <panel-block id="pn-collect-date-time">
    <panel-item>
      <row>
        <prefix v-if="isLockable">
          <lock
            :configurable="isLockConfigurable"
            v-model="model[lockProperty]"
          ></lock>
        </prefix>
        <column>
          <label for="collectDate">
            Collect date/time?
            <slot name="modeLabel"></slot>
          </label>
        </column>
      </row>
      <a-select
        ref="modeComponent"
        @input="setDatetimeMode"
        :options="datetimeModeVOptions"
        id="collectDate"
        compress
        :disabled="disabled"
        :value="model.datetime_mode"
      ></a-select>
    </panel-item>
  </panel-block>

  <panel-block id="pn-time-format"
               v-if="datetimeMode !== DatetimeMode.Date">
    <panel-item>
      <label for="timeFormat">
        Time Format
        <slot name="timeFormatLabel"></slot>
      </label>
      <a-select
        v-model="model.time_format"
        :options="timeFormatVOptions"
        id="timeFormat"
        compress
        :disabled="disabled"
      ></a-select>
    </panel-item>
  </panel-block>

  <panel-block id="pn-date-time-type" panel-group>
    <panel-item>
      <date-min-max-value-selector
        :datetime-mode="datetimeMode"
        :parent="model"
        field-name="min_datetime"
        display-name="Minimum"
        :date-picker-props="{max: maxDatetime}"
        :custom-min-max-type-options="customMinMaxTypeOptions"
        :allow-formula="allowFormula"
        :dynamic-options="formulaDynamicFieldsOptions"
      >
        <template #label>
          <slot name="minLabel"></slot>
        </template>
      </date-min-max-value-selector>
    </panel-item>

    <panel-item>
      <date-min-max-value-selector
        :datetime-mode="datetimeMode"
        :parent="model"
        field-name="max_datetime"
        display-name="Maximum"
        :date-picker-props="{min: minDatetime}"
        :custom-min-max-type-options="customMinMaxTypeOptions"
        :allow-formula="allowFormula"
        :dynamic-options="formulaDynamicFieldsOptions"
      >
        <template #label>
          <slot name="maxLabel"></slot>
        </template>
      </date-min-max-value-selector>
    </panel-item>
  </panel-block>
</div>
